import { NavigateFunction } from 'react-router-dom';
import tempStorage from 'app/route/tempStorage';

let history;

function setHistory(value: NavigateFunction) {
    history = value;
}

function isStatic(): boolean {
    return !history;
}

function navigate(
    url: string,
    params: { replace: boolean } = { replace: false },
    paramsForNextRoute: Record<string, any> = undefined,
) {
    if (isStatic()) {
        window.location.href = url;
        return;
    }

    tempStorage.set(paramsForNextRoute);

    history(url[0] !== '/' ? `/${url}` : url, { replace: !!params.replace });
}

function reload() {
    document.location.reload();
}

function isHere(url: string) {
    const idx = Math.max(document.location.href.indexOf('index.html'), 0);
    const path = `/${document.location.href.slice(idx)}`;

    return path.match(url);
}

function goBack() {
    history(-1);
}

export { isHere, navigate, reload, setHistory, goBack, isStatic };
